/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerEntityType = {
    Llc: 'LLC',
    CCorp: 'C_CORP',
    SCorp: 'S_CORP',
    Partnership: 'PARTNERSHIP',
    SoleProprietor: 'SOLE_PROPRIETOR'
} as const;
export type CustomerEntityType = typeof CustomerEntityType[keyof typeof CustomerEntityType];

